import {
    addClass,
    event, hasClass,
    removeClass,
    removeClassAll,
    selectArr,
    selectDoc
} from "../utils/utils";

import Glide from "../lib/glide.min";
import {lazyLoadShow} from "../components/component.animate";

/**
 *
 * @param container
 * @param configs
 * @param adaptPerView
 * @returns {*}
 */
export const initSlider = (container, configs, adaptPerView = false) => {
    /**
     * Slider sprite
     */
    let buttonsContainer = selectDoc(container + ' #glide-sprite'),
        arrowsContainer = selectDoc(container + ' .slider-controls');
    if (buttonsContainer) {
        let slidesContainer = selectDoc(container + ' .glide__slides');
        if (slidesContainer) {
            if (slidesContainer.innerHTML.trim().length > 0) {
                /**
                 * Slider Bullets
                 */
                buttonsContainer.innerHTML = '';
                let containerClass = container.replace('#', '').replace('.', ''),
                    slidersCount = selectArr(container + ' .glide__slide').length;
                for (let i = 0; i < slidersCount; i++) {
                    buttonsContainer.innerHTML += `<button data-glide-dir="=${i}" class="${containerClass}-bullet bullet ${i < 1 ? 'glide__bullet--active' : ''}"><div class="circle"></div></button>`
                }

                /**
                 * Slider Init
                 */
                let glider = new Glide(container, configs).mount();

                /**
                 * Slider Events
                 */
                if (adaptPerView) {
                    glider.on('run.before', evt => {
                        const scrollSteps = glider.settings.perView;
                        evt.steps = evt.direction === '>' ? -scrollSteps : scrollSteps;
                    });

                    let bullets = selectArr(container + ' button.bullet');
                    bullets.map((bullet, i) => {
                        if((i+1) === bullets.length) {
                            removeClass(bullet, 'hide')
                        } else {
                            i % glider.settings.perView ? addClass(bullet, 'hide') : removeClass(bullet, 'hide')
                        }
                    })

                    glider.on('resize', evt => {
                        let bullets = selectArr(container + ' button.bullet');
                        bullets.map((bullet, i) => {
                            if((i+1) === bullets.length) {
                                removeClass(bullet, 'hide')
                            } else {
                                i % glider.settings.perView ? addClass(bullet, 'hide') : removeClass(bullet, 'hide')
                            }
                        })
                    });
                }

                /**
                 * Slider Arrows
                 */
                if (arrowsContainer) {
                    let left = selectDoc('button.left', arrowsContainer),
                        right = selectDoc('button.right', arrowsContainer);

                    if (left) {
                        addClass(left, 'last')
                    }

                    glider.on('run.after', evt => {
                        if (selectDoc(container + ' #glide-sprite .bullet.glide__bullet--active:last-child')) {
                            if (right) {
                                addClass(right, 'last')
                            }
                            if (left) {
                                removeClass(left, 'last')
                            }
                        } else {
                            if (selectDoc(container + ' #glide-sprite .bullet.glide__bullet--active:first-child')) {
                                if (left) {
                                    addClass(left, 'last')
                                }
                                if (right) {
                                    removeClass(right, 'last')
                                }
                            } else {
                                if (left) {
                                    removeClass(left, 'last')
                                }
                                if (right) {
                                    removeClass(right, 'last')
                                }
                            }
                        }
                    });
                }

                return glider;
            }
        }
    }
}

/**
 *
 * @param container
 * @param configs
 * @param adaptPerView
 * @param hand
 * @param PDP
 * @returns {*}
 */
export const initSliderPDP = (container, configs, adaptPerView = false, hand, PDP) => {
    let glide = initSlider(PDP.main + ' ' + container, configs, adaptPerView);

    window.glideSlider = glide;

    if(PDP.isQuickView) {
        //Show controllers
        removeClass(selectDoc(PDP.main + ' .slider-controls'), 'mobile-only')

        //Initial glide state
        glideState('col col-md-9 col-lg-6', glide, 100000, PDP.main + ' #product-images-slider');

        //Lazyload images
        selectArr(PDP.main + ' ' + container + ' .lazy-load').map(image => {
            lazyLoadShow(image)
        })
    } else {
        //Initial glide state
        glideState('col col-md-9 col-lg-6', glide, 100000, PDP.main + ' #product-images-slider');

        //On glide resize glide state
        event(window, 'resize', function() {
            glideState('col col-md-9 col-lg-6', glide, 100000, PDP.main + ' #product-images-slider');
        });
    }

    //View on hand event
    if (hand) {
      event(hand, 'click', function () {
        glide.go('>>')
      });
    }

    glide.on('move', function(obj) {
      const glideId = glide.index;

      if (!isNaN(glideId)) {
        $('.js-carousel-thumbnail').each((i, thumb) => {
          const $thumb = $(thumb);

          if ($thumb.data('glide-id') == glideId) {
            $thumb.addClass('active');
          } else {
            $thumb.removeClass('active');
          }
        });
      }
    });

    $(document).on('click', '.js-carousel-thumbnail', function(e) {
      const $target = $(e.currentTarget);
      const slideId = $target.data('glide-id');

      if (slideId !== undefined) {
        glide.go(`=${ slideId }`);
      }
    });

    return glide;
}

/**
 *
 * @param desktopClass
 * @param glide
 * @param breakpoint
 * @param containerSelector
 */
export const glideState = (desktopClass, glide, breakpoint, containerSelector = '') => {
    if(!glide) {
        return
    }

    if (window.innerWidth <= breakpoint) {
        let track = selectDoc(`${containerSelector} .glide__grid`),
            slides = selectArr(`${containerSelector} .glide__grid .glide__col`);

        if(track) {
            removeClass(track, 'glide__grid')
            addClass(track, 'glide__slides')
            track.setAttribute('style', '')

            removeClassAll(slides, 'glide__col')
            slides.map(s => {
                if(hasClass(s, 'hide-variant-img')) {
                    s.className =  `glide__slide hide-variant-img`
                } else {
                    s.className = `glide__slide`
                }
                s.setAttribute('style', '')
            });
        }

        glide.update({
            perView: 1,
            type: 'slider',
            rewind: true,
            bound: true
        }).enable();

    } else {
        let track = selectDoc(`${containerSelector} .glide__slides`),
            slides = selectArr(`${containerSelector} .glide__slides .glide__slide`);

        if(!track) {
            track = selectDoc(`${containerSelector} .glide__grid`);
            slides = selectArr(`${containerSelector} .glide__grid .glide__col`)
        }

        glide.update({
            startAt: 0,
            perView: 1,
            gap: 0,
            peek: 0
        }).disable();

        removeClass(track, 'glide__slides')
        addClass(track, 'glide__grid')
        track.setAttribute('style', '')

        removeClassAll(slides, 'glide__slide')
        slides.map(s => {
            if(hasClass(s, 'hide-variant-img')) {
                s.className =  `glide__col ${desktopClass} hide-variant-img`
            } else {
                s.className =  `glide__col ${desktopClass}`
            }
            s.setAttribute('style', '')
        });
    }
}
